export default "__VITE_ASSET__BD3L8VFt__"